<template>
<div ref="businessproject" class="pbr-index-chart">
</div>
</template>

<script>
import * as echarts from 'echarts'
import Mixin from '../mixin'
import {chartColors} from '../../../analysis/constant'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartBusinessType',
  mixins: [Mixin],
  inject: ['chartDatas'],
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    height: { type: Number }
  },
  data () {
    return {
      businessProjectChart: null,
      optionBusinessproject: null,
      isResize: true,
    }
  },
  computed: {
    chartData () {
      const businessChartData = this.chartDatas.businessChartData()
      // return projectChartData.businessTypeChart || [{}]
      if (businessChartData.hasOwnProperty('businessTypeChart') && businessChartData.businessTypeChart.length > 0) {
        return businessChartData.businessTypeChart
      }
      return [{name: '', num: 0, percent: 0}]
    },
  },
  methods: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.businessproject){
        return
      }
      if (this.businessProjectChart) {
        this.businessProjectChart.dispose()
      }
      let countContrastDom = this.$refs.businessproject
      this.businessProjectChart = echarts.init(countContrastDom, theme,)
      this.businessProjectChart.setOption(this.optionBusinessproject)
      this.businessProjectChart.on('click', function (param) {
        // self.$emit('business-project-chart-click', param)
        // self.dispatch('pbrIndex', 'filterData', {module: 'sj', projectName: param.name})
        // self.$store.commit('pbrIndexModule', {business: {project: 1, projectName: param.name}})
        self.dispatch('pbrIndex', 'filterData', {module: 'sj', condition: {type: 'category', title: param.data.name, id: param.data.id}})
      })
      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.businessProjectChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      let self = this
      this.optionBusinessproject = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.opportunity.distribution'),
          left: 'center',
          top:0
        },
        tooltip: {
          trigger: 'item',
          confine: true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          formatter: function (a) {
            console.log(a)
            // return params.name + " - " + params.percent + '%'
           let listItem = `${a.seriesName}<br /><i style="display: inline-block;width: 10px;height: 10px;background: ${a.color};margin-right: 5px;border-radius: 50%;}"></i>
                            ${a.value.name}<br/><p style="padding-left:20px;">${self.$t('charts.home.opportunity.number')} ：${a.value.num}</br>${self.$t('charts.home.opportunity.percentage')} ：${a.percent}%</p>`

            return '<div class="showBox">' + listItem + '</div>'
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        legend: {
          type:'scroll',
          orient: 'horizontal',
          top: this.showTitle ? 20 : 0,
          itemWidth:10,
          itemHeight:10,
          textStyle: {
            color: self.isDark() ?  '#ebedee' : '#101010'
          },
          tooltip: {
            show: true,
            // position: ['50%', '50%'],
            // position: function (p) { // 其中p为当前鼠标的位置
            //   return [p[0] + 10, p[1] - 10]
            // },
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
          },
        },
        dataset: {
          dimensions: ['name', 'num', 'percentage'],
          source: this.chartData
        },
        series: [{
          name: this.$t('charts.home.opportunity.distribution'),
          type: 'pie',
          radius: '100%',
          top: this.showTitle ? 50 : 30,
          bottom:10,
          center: ['50%', '50%'],
          labelLine: {
            show: false
          },
          label: {
            //   show: false,
            normal: {
              // formatter: '{@percentage}',
              formatter:'{d}%',
              position: 'inside',
              fontSize: 8,
              color: '#fff',
              align: 'center',
              verticalAlign: 'middle'
            }
          },
          emphasis: {
            itemStyle: {
              fontSize: 8
            }
          }
        }]
      }
    },
    resize () {
      this.isResize = true;
      this.businessProjectChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.businessProjectChart) {
            this.businessProjectChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
